import React from "react";
import "./index.m.css";
import Whatsapp from "../../../atoms/social-media-icons/Whatsapp";
import Mail from "../../../atoms/social-media-icons/Mail";

export const FooterSection = () => {
  return (
    <div styleName="footerWrapper">
      <section styleName="footerSection" aria-label="Contact and Support">
        <div styleName="contactHeading">
          <span styleName="headingNormal">ಸಮಸ್ಯೆ ಎದುರಿಸುತ್ತಿದ್ದೀರಾ? </span>
          <span styleName="headingBold">ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ</span>
        </div>

        <div styleName="contactBoxes">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.open("https://api.whatsapp.com/send/?phone=919035267304&text=Hi%2C%20I%20need%20assistance%20with%20my%20Prajavani%20Premium%20Subscription.%20Could%20you%20please%20help%20me%3F&type=phone_number&app_absent=0", "_blank", "noopener,noreferrer");
            }}
            styleName="contactBox"
          >
            <Whatsapp width={18} height={18} color="#25D366" />
            <span styleName="whatsappText">+91 9035267304</span>
          </a>

          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.open("https://mail.google.com/mail/u/0/?fs=1&to=support@prajavani.net&su=Support+Required+for+PV+subscription&body=Hi%2C+I+need+assistance+with+my+Prajavani+Premium+Subscription.+Could+you+please+help+me%3F&tf=cm", "_blank", "noopener,noreferrer");
            }}
            styleName="contactBox emailBox"
          >
            <Mail width={16} height={12} color="#000" />
            <span styleName="emailText">
              support@prajavani.net
            </span>
          </a>
        </div>

        <div styleName="workingHoursContainer">
          <div styleName="workingHoursLabel">ಕೆಲಸದ ಸಮಯ</div>
          <div styleName="workingHoursTime">ಸೋಮವಾರದಿಂದ ಶುಕ್ರವಾರ: ಬೆಳಿಗ್ಗೆ 10 ರಿಂದ ಸಂಜೆ 6</div>
        </div>
      </section>
    </div>
  );
};
